/* eslint-disable import/prefer-default-export */
import DashTour from './components/DashTour.react';

export {
    DashTour
};
